import { Injectable, TemplateRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PageHeaderService {
  private rightContentSubject = new BehaviorSubject<TemplateRef<any> | null>(null);

  rightContent$ = this.rightContentSubject.asObservable();

  setRightContent(template: TemplateRef<any> | null) {
    this.rightContentSubject.next(template);
  }
}